<template>
  <div v-if="isLogged"
       class="user-bar">
    <div class="user-bar__item account-dropdown">
      <button type="button"
              class="account-dropdown__trigger base-link user-bar__link"
              @click.prevent="onOpenAccountDropdown"
      >
        <BaseSvg name="ico-user"
                 width="1.5rem"
                 height="1.4rem"
                 class="base-link__ico"
        />
        <span class="base-link__text">{{ $tHeader('My account') }}</span>
        <BaseSvg name="ico-arrow"
                 class="select-dropdown__trigger-arrow"/>
      </button>

      <transition name="dropdown">
        <div v-if="isAccountDropdownOpen"
             v-click-out="onCloseAccountDropdown"
             class="account-dropdown__dropdown">
          <button type="button"
                  class="account-dropdown__close"
                  @click.prevent="onCloseAccountDropdown"
          >
            <BaseSvg name="ico-close"
                     width=".8rem"
                     height=".8rem"/>
          </button>
          <div class="account-dropdown__head">
            <img v-if="user.avatar"
                 :src="user.avatar"
                 :alt="user.fullname">
            <div v-else
                 class="account-dropdown__ico-avatar">
              <BaseSvg name="ico-avatar-clear"/>
            </div>
            <span>{{ user.fullname }}</span>
          </div>
          <ul class="account-dropdown__list">
            <li v-for="item in menu"
                :key="item.name + userType"
                :class="callOrDisplay(item.disabled) ? '_disabled' : null">
              <router-link-modified :to="item.route"
                                    class="account-dropdown__link">
                {{ $tHeader(item.name) }}
                <span v-if="typeof item.badge === 'function' && item.showBadge && runInContext(item.showBadge)"
                      class="account-dropdown__link-badge">
                  {{ runInContext(item.badge) }}
                </span>
              </router-link-modified>
            </li>
          </ul>
          <div class="account-dropdown__footer">
            <button @click.prevent="onClickLogout"
                    class="account-dropdown__logout  base-btn  base-btn--outline-dark  base-btn--small">
              <span>{{ $tHeader('Logout') }}</span>
              <BaseSvg name="ico-logout"
                       width="1.5rem"
                       height="1.1rem"/>
            </button>
          </div>
        </div>
      </transition>
    </div>
<!--    <div class="user-bar__item" v-if="isAgent">-->
<!--      <router-link-modified :to="{name: 'account-balance'}"-->
<!--                            class="base-link user-bar__link">-->
<!--        <span class="base-link__text">{{ $tHeader('Balance') }}</span>-->
<!--        <span class="base-link__badge">{{ user.balance }} <b>JBN</b></span>-->
<!--      </router-link-modified>-->
<!--    </div>-->
    <HeaderUserPanelBookmarks/>
    <button @click.prevent="openNotifications"
            type="button"
            :class="newNotificationCount ? '_new' :  null"
            class="user-bar__bell">
      <!--add ^ _new for ring-->
      <BaseSvg name="ico-bell-stroke"/>
      <transition name="fade">
        <span v-if="newNotificationCount > 0" class="main-header__bar-btn-note">{{ newNotificationCount }}</span>
      </transition>
    </button>
  </div>
  <div v-else
       class="user-bar">
    <HeaderUserPanelBookmarks/>
    <div class="user-bar__auth-wrap">
      <BaseSvg name="ico-user"
               width="1.5rem"
               height="1.4rem"
               class="user-bar__auth-ico  _green"/>
      <router-link-modified :to="{name: 'auth'}"
                            tag="div"
                            class="user-bar__auth-link">
        {{ $tHeader('Login') }}
        /
        {{ $tHeader('Registration') }}
      </router-link-modified>
    </div>
    <div class="user-bar__auth-wrap">
      <BaseSvg name="ico-tie"
               width="0.8rem"
               height="2rem"
               style="top: 0.1rem; position: relative"
               class="user-bar__auth-ico  _green"/>
      <router-link-modified :to="{name: 'auth-agent'}"
                            tag="div"
                            class="user-bar__auth-link">
        {{ $tHeader('For agents') }}
      </router-link-modified>
    </div>
  </div>
</template>

<script>
  import {EMPLOYEE, EMPLOYER, PARTNER, MODERATOR, AGENT} from '@/constants/usersTypes'
  import {mapGetters, mapMutations, mapState} from "vuex"
  import HeaderUserPanelBookmarks from "./HeaderUserPanelBookmarks"

  const menuEmployee = [
    {
      name: 'Resumes',
      route: {name: 'account-my-resume'}
    },
    {
      name: 'My vacancies',
      route: {name: 'account-my-vacancies'}
    },
    {
      name: 'Interaction',
      route: {name: 'account-interaction'}
    },
    {
      name: 'Mailing',
      route: {name: 'account-mailing'},
      disabled: true
    },
    {
      name: 'Help',
      route: {name: 'help'}
    }
  ]

  const menuPartner = [
    {
      name: 'Dashboard',
      route: {name: 'account-dashboard'},
      disabled: true
    },
    {
      name: 'Resume base',
      route: {name: 'account-partner-resumes-base'},
    },
    {
      name: 'Employees',
      route: {name: 'account-employees'},
      disabled: true
    },
    {
      name: 'Affiliate network',
      route: {name: 'account-partner-partners-network'}
    },
    {
      name: 'My responses',
      route: {name: 'account-vacancies-responses'},
      showBadge() {
        return !!Number(this.receivedNewResumesCount);
      },
      badge: function () {
        return this.receivedNewResumesCount ? '+ ' + this.receivedNewResumesCount : this.receivedNewResumesCount;
      }
    },
    // {
    //   name: 'Balance',
    //   route: {name: 'account-balance'}
    // },
    {
      name: 'Statistic',
      route: {name: 'account-partner-statistic'},
    },
    {
      name: 'Useful materials',
      route: {name: 'account-useful-materials'},
    },
    {
      name: 'Mailing',
      route: {name: 'account-mailing'},
      disabled: true
    }
  ]

  const menuEmployer = [
    {
      name: 'Profile',
      route: {name: 'account-employer-profile-edit'}
    },
    {
      name: 'Vacancies',
      route: {name: 'account-vacancies'}
    },
    {
      name: 'My responses',
      route: {name: 'account-vacancies-responses'},
      showBadge() {
        return !!Number(this.receivedNewResumesCount);
      },
      badge: function () {
        return this.receivedNewResumesCount ? '+ ' + this.receivedNewResumesCount : this.receivedNewResumesCount;
      }
    },
    // {
    //   name: 'Help',
    //   route: {name: 'help'}
    // }
  ]

  const menuModerator = [
    {
      name: 'Candidates',
      route: {name: 'account-moderator-candidates'}
    },
    {
      name: 'Marketing',
      route: {name: 'account-moderator-marketing'}
    },
    {
      name: 'Statistic',
      route: {name: 'account-moderator-statistic'},
    },
  ]

  const menuAgent = [
    {
      name: 'Dashboard',
      route: {name: 'account-dashboard'},
      disabled: true
    },
    {
      name: 'Resume base',
      route: {name: 'account-agent-resumes-base'},
    },
    {
      name: 'Employees',
      route: {name: 'account-employees'},
      disabled: true
    },
    // {
    //   name: 'Balance',
    //   route: {name: 'account-balance'}
    // },
    {
      name: 'My responses',
      route: {name: 'account-vacancies-responses'},
      showBadge() {
        return !!Number(this.receivedNewResumesCount);
      },
      badge: function () {
        return this.receivedNewResumesCount ? '+ ' + this.receivedNewResumesCount : this.receivedNewResumesCount;
      }
    },
    {
      name: 'Statistic',
      route: {name: 'account-agent-statistic'},
    },
    {
      name: 'Useful materials',
      route: {name: 'account-useful-materials'},
    },
    {
      name: 'Mailing',
      route: {name: 'account-mailing'},
      disabled: true
    }
  ]

  export default {
    name: 'HeaderUserPanel',
    components: {
      HeaderUserPanelBookmarks
    },
    data() {
      return {
        pending: false,
        isAccountDropdownOpen: false,

        EMPLOYEE,
        EMPLOYER,
        PARTNER,
        MODERATOR,
      }
    },
    computed: {
      ...mapState('user', [
        'resume',
        'moderatedPassport',
        'profile',
        'openedInteractionId',
      ]),
      ...mapGetters('user', [
        'isLogged',
        'hasInteraction',
        'receivedNewResumesCount',
      ]),
      ...mapState('user/userNotifications', [
        'newNotificationCount',
      ]),
      user() {
        return this.profile
      },
      userType() {
        return this.profile && this.$store.state.user.profile.user_type
      },
      isAgent() {
        return this.userType === PARTNER
      },
      menuEmployeeComputed() {
        const result = [...menuEmployee]

        if (!this.hasInteraction) {
          result.splice(2, 1)
        } else {
          result[2].route.params = {
            id: this.openedInteractionId
          }
          result.splice(1, 1)
        }

        result[0].disabled = !this.resume

        return result
      },
      menu() {
        switch (this.userType) {
          case EMPLOYER:
            return menuEmployer
          case EMPLOYEE:
            return this.menuEmployeeComputed
          case PARTNER:
            return menuPartner
          case MODERATOR:
            return menuModerator
          case AGENT:
            return menuAgent
        }

        return null
      },
      approvedResumesCount() {
        return this.$store.getters['user/approvedResumesCount'];
      },
    },
    methods: {
      ...mapMutations('user/userNotifications', [
        'openNotifications',
      ]),
      callOrDisplay(funcOrProp) {
        if (typeof funcOrProp === 'function') return this.runInContext(funcOrProp);
        return funcOrProp;
      },
      onClickLogout() {
        if (this.pending) return;
        this.pending = true;

        this.$store.dispatch('user/logoutUser', { userType: this.userType })
          .finally(() => this.pending = false);
      },
      onOpenAccountDropdown() {
        this.isAccountDropdownOpen = true
      },
      onCloseAccountDropdown() {
        this.isAccountDropdownOpen = false
      },
      runInContext(func) {
        return func.call(this)
      },
    },
    watch: {
      '$route.name'() {
        this.onCloseAccountDropdown()
      }
    },
    created() {

    }
  }
</script>

<style lang="less">

</style>
